<template>
  <el-dialog
    v-el-drag-dialog
    no="ReleaseJY"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.TakeContainerJY')"
    :close-on-click-modal="false"
    width="500px"
    @close="dialogClose"
  >
    <div style="display:flex;margin-top:20px;">
      <span style="margin: 5px">{{ $t('SeaExport.TakeContRemarks') }}</span>
      <div style="width:70%;margin-left:10px">
        <el-input v-model="remark" type="textarea" :rows="5" no="remark" />
      </div>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="jyTakeContainer()">{{ $t('common.btn.confirm') }}</el-button>
      <el-button @click="dialogClose">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { postTakeContPlan } from '@/api/booking/jyWarehouse'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'JyTakeContainerDialog',
  props: {
    visible: { type: Boolean, default: false },
    callback: { type: Function, default: null },
    job: { type: Object, required: true },
    containers: { type: Array, default: () => [] }
  },
  data() {
    return {
      innerVisible: false,
      loading: false,
      remark: ''
    }
  },
  computed: {

  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (this.visible) {
        this.onShow()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.onShow()
    }
  },
  methods: {
    dialogClose() {
      this.$emit('update:visible', false)
    },
    onShow() {
      this.remark = ''
    },
    jyTakeContainer() {
      if (!this.containers || this.containers.length === 0) {
        this.$message.warning(this.$t('SeaExport.NoData'))
        return
      }
      const warehouse = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', this.job.warehouseCmp)
      if (!warehouse) {
        this.$message.warning(this.$t('SeaExport.warehouseNotNull'))
        return
      }
      const jySeaExpOrderList = []
      for (const item of this.containers) {
        const jySeaExpOrder = {
          custbizNo: this.job.jobNo + '-' + item.containerId,
          blNo: this.job.mbl,
          remark: this.remark
        }
        jySeaExpOrderList.push(jySeaExpOrder)
      }
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        jobUuid: this.job.uuid,
        warehouse: warehouse.cnShortName,
        jySeaExpOrderList: jySeaExpOrderList
      }
      this.loading = getLoading4Cxt()
      postTakeContPlan(data).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SentSuccessfully'))
        }
        this.dialogClose()
        if (this.callback) {
          this.callback()
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>
